module.exports = __webpack_public_path__ + "3896600bcfef00eabc82ec1634fc724d.pdf";